import { createSelector } from '@reduxjs/toolkit'

const getBankAccount = (state) => state.bankAccount
const getTaxReturns = (state) => state.profile.taxReturns
const getQuarterlyTaxReturns = (state) => state.profile.quarterlyTaxReturns

const getBankAccountLast4Digits = createSelector([getBankAccount], (bankAccount) => bankAccount.iban?.slice(-4) || '')

const getHasFilledBankDetails = createSelector([getBankAccount], (bankAccount) => !!bankAccount.iban)

const shouldFillDetails = createSelector(
    [getHasFilledBankDetails, getTaxReturns, getQuarterlyTaxReturns],
    (hasFilledBankDetails, taxReturns, quarterlyTaxReturns) => {
        if (hasFilledBankDetails) return false

        const hasTaxReturns = taxReturns && taxReturns.length > 0
        const hasQuarterlyTaxReturns = quarterlyTaxReturns && quarterlyTaxReturns.length > 0

        if (hasTaxReturns || hasQuarterlyTaxReturns) return true

        return false
    }
)

const bankAccountSelector = createSelector(
    [getBankAccount, getHasFilledBankDetails, shouldFillDetails, getBankAccountLast4Digits],
    (bankAccount, hasFilledBankDetails, shouldFillBankDetails, bankAccountLast4Digits) => ({
        ...bankAccount,
        bankAccountLast4Digits,
        hasFilledBankDetails,
        shouldFillBankDetails,
    })
)

export default bankAccountSelector
